import axios from "axios";
let service 


  function initService(){
	service = axios.create({
	    timeout: 300000,
	    headers: {
	        'accept':'*/*',
	        'Authorization':localStorage.getItem("Authorization")
	    }
	  }); 	
	  service.interceptors.response.use(
		response => {
		  // 请求成功，返回response
		  return response;
		},
		error => {
		  if (error.response) {
			// 请求已发出，服务器用状态码响应
			switch (error.response.status) {
			  case 400:
				// 处理400错误
				console.log('Error 400: Bad Request');
				router.push({name:'Home'})
				// 可以在这里进行错误处理，例如提示用户或者重新请求
				break;
			  // 可以根据需要处理其他错误码
			  default:
				console.error(`Error: ${error.response.status}`);
			}
		  } else if (error.request) {
			// 请求已发出但没有收到响应
			// 处理请求错误
			console.error('Error: No response received');
		  } else {
			// 在请求构建过程中出错
			console.error('Error:', error.message);
		  }
		  return Promise.reject(error);
		}
	  );
 }
 
  //  获取apikey用户信息 
export function getMyApiInfo(params) {
    return service.post('/apikey'+'/key/info', 
        transObjToParamStr(params)
    )
}

  //  获取用户信息  POST /api/v1/user/info
  export function getMyInfo(params) {
    initService()
    return service.post('/apikey'+'/user/info', 
        transObjToParamStr(params)
    )
}

// 注册账户 POST /api/v1/user/register
export function registerUser(params) {
    return service.post('/apikey'+'/auth/register', 
        transObjToParamStr(params)
    )
}
// 用户登录 POST /api/v1/user/login
export function login(params) {
    return service.post('/apikey'+'/auth/login', 
        transObjToParamStr(params)
    )
}

// 确认邮箱  POST /api/v1/confirmEmail
export function confirmEmail(params) {

    return service.post('/apikey'+'/email/confirmEmail', 
        transObjToParamStr(params)
    )
}

// 获取邮箱验证码 POST /api/v1/verifyCode
export function sendVerifyCode(params) {
    return service.post('/apikey'+'/email/sendCode', 
        transObjToParamStr(params)
    )
}

//人机认证  /auth/siteverify
 export function checkToken(params) {
   
    return service.get('/apikey'+"/auth/siteverify?"+transObjToParamStr(params)

    )}


// 修改密码 /api/v1/user/updatePassword
export function updatePassword(params) {
    
    return service.post('/apikey'+'/auth/updatePassword', 
        transObjToParamStr(params)
    )
}

//退出登录  POST /api/v1/user/loginOut 
export function loginOut(params) {
    return service.post('/apikey'+'/user/loginOut', 
        transObjToParamStr(params)
    )
}

// Newsletter api/1.0/email/gather.do
export function Newsletter(params) {
    return service.post('/newsletter'+"/email/gather.do", 
    transObjToParamStr(params)
    )
}

// /api/statistics/apilog/logList
export function getLogList(params) {
    return service.post( `/apikey`+"/statistics/apilog/logList", 
    transObjToParamStr(params)
    )
}

// /api/statistics/apilog/chart

export function getchartData(params) {
    return service.post( `/apikey`+"/project/statics", 
    transObjToParamStr(params)
    )
}

//  create project
export function createProject(params) {
    
    return service.post( `/apikey`+"/project/save", 
    transObjToParamStr(params)
    )
}

// get project list 
export function getProjectList(params) {
    
    return service.post( `/apikey`+"/project/list", 
    transObjToParamStr(params)
    )
}

// delete project
export function deleteProject(params) {
    
    return service.post( `/apikey`+"/project/delete", 
    transObjToParamStr(params)
    )
}

// get static project list /api/v1/project/myProjects
export function getStaticProjectList(params) {
    
    return service.post( `/apikey`+"/project/myProjects", 
    transObjToParamStr(params)
    )
}

// get user balance

export function getUserBalance() {
    initService()
    return service.post( `/apikey`+"/user/balance"
    
    )
}
export function getMyOrderList() {
    
    return service.post( `/apikey`+"/order/myOrders"
   
    
    )
}

// /api/v1/project/myApis
export function getMyApis() {
    return service.post( `/apikey`+"/project/myApis"

    )
}





function transObjToParamStr(object) {
   
let arr=[]
    for (const key in object) {
        if (Object.hasOwnProperty.call(object, key)) {
            const element = object[key];
            arr.push(`${key}=${element}`);
        }
    }
    return arr.join('&');
}